
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"16","viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1539_17930)"}},[_c('path',{attrs:{"d":"M17.4818 9.14286H11.0382V14.8571C11.0382 15.4857 10.4583 16 9.7495 16C9.04071 16 8.46079 15.4857 8.46079 14.8571V9.14286H2.01723C1.30844 9.14286 0.728516 8.62857 0.728516 8C0.728516 7.37143 1.30844 6.85714 2.01723 6.85714H8.46079V1.14286C8.46079 0.514286 9.04071 0 9.7495 0C10.4583 0 11.0382 0.514286 11.0382 1.14286V6.85714H17.4818C18.1906 6.85714 18.7705 7.37143 18.7705 8C18.7705 8.62857 18.1906 9.14286 17.4818 9.14286Z","fill":"white"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1539_17930"}},[_c('rect',{attrs:{"width":"18.042","height":"16","fill":"white","transform":"translate(0.728516)"}})])])])
          )
        }
      }
    